import api from '@/api'
import dtacGamingApi from '@/api/dtac-gaming'
import Editable from '@/components/elements/Editable'
import uploadfile from '@/components/elements/uploadfile'
import config from '@/config'
import { PAGE } from '@/constants/page.js'
import { calculateShippingPrice, getBangkokLocation } from '@/nvbb.js'
import axios from 'axios'
import $ from 'jquery'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Nl2br from 'vue-nl2br'
import { mapGetters } from 'vuex'
import CityFreshShippingDate from './CityFreshShippingDate.vue'
import PrintAllCovers from './PrintAllCovers.vue'
import PrintAllCoversCentral from './PrintAllCoversCentral.vue'
import PrintCover from './PrintCover'
import SelectGmap from './SelectGmap'
import SetShippingDatetime from './SetShippingDatetime.vue'

import { ACOMMERCE_STATUS_OPTIONS, STATUS_OPTIONS } from '@/constants/acommerce.js'

export default {
  props: ['value', 'cbAll', 'shippingOptions', 'showProductDetail'],
  data: function () {
    return {
      phoneNumber: null,
      name: null,
      showToAddress: false,
      dataEdit: null,
      order_json: null,
      toggleDroppoint: false,
      toggleHub: false,
      droppointSelect: null,
      hubSelect: null,
      cb: false,
      showDetail: false,
      showPrint: false,
      status: {
        label: this.$t('ordered'),
        value: 'ordered',
        firstinit: true
      },
      statusPay: {
        label: this.$t('โอนเงิน'),
        value: 'payment',
        firstinit: true
      },
      nameEdit: null,
      driverRemark: null,
      shippingValue: '',
      cart_remark: '',
      orderToMove: null,
      showMoveToOrder: false,
      nvbb: {
        shippingAddress: '',
        showDatePicker: false,
        mindate: null,
        shippingType: null,
        pickupdate: null,
        hubLocation: null,
        hubLocationOptions: [
          {
            text: 'Smizzle Burger พระราม 4 - สุขุมวิท 26',
            value: 'พระราม 4 - สุขุมวิท 26',
            desc: `📍พระราม 4 - สุขุมวิท 26📍\n⭐️ Smizzle Burger\nอยู่ใน Bambini Villa Community Mall\n🕓 ช่วง 13:00-20:00 (02-0564336)`,
            link: 'https://goo.gl/maps/GXujUmxgoyha8xzR8'
          },
          {
            text: 'สนาม Flick FootBall วังทองหลาง - ลาดพร้าว',
            value: 'วังทองหลาง - ลาดพร้าว',
            desc: `📍วังทองหลาง - ลาดพร้าว 📍\n⭐️ สนาม Flick FootBall (ใกล้ Central EastVille 1 นาที)\n> ช่วง 14:00-21:30 (098-8892203)`,
            link: 'https://maps.app.goo.gl/qBvH8Ehnccsr689y7'
          },
          {
            text: 'ร้าน Sweet tooth พันท้ายนรสิงห์',
            value: 'พันท้ายนรสิงห์',
            desc: `📍พันท้ายนรสิงห์📍\n⭐️หมู่บ้านเดอะแกรนด์ ร้าน Sweet tooth\n🕓 ก่อน 9:00-17:00 (083-8886333)`
          },
          {
            text: 'ร้าน BAANTOON Cafe',
            value: 'บางบอน - บางแค',
            desc: `📍ใกล้กับ รพ.สมุทรสาคร📍\nร้าน BAANTOON Cafe\nCall : 034-423433`,
            link: 'https://goo.gl/maps/3t16hNmM86MA5yq56'
          },
          {
            text: 'Farm Friends & Rainbow',
            value: 'Farm Friends & Rainbow',
            desc: `เวลาทำการ 11:00-20:30\n โทร 063 198 8148\n ** ปิดวันอังคาร **`,
            link: 'https://www.google.com/maps/place/Farm+Friends+%26+Rainbow/@13.7733221,100.4905606,17z/data=!3m1!4b1!4m5!3m4!1s0x30e29998e4abbfed:0xca27b37d4f39271d!8m2!3d13.7733221!4d100.4905606'
          }
        ],
        loading: false
      }
    }
  },
  components: {
    Editable,
    PrintCover,
    PrintAllCovers,
    Multiselect,
    Nl2br,
    PrintAllCoversCentral,
    SelectGmap,
    CityFreshShippingDate,
    SetShippingDatetime,
    uploadfile
  },
  computed: {
    remarkToDriver() {
      var options = [
        {
          label:
            'รบกวนโทรหาปลายทางก่อนออกจัดส่งด้วยนะคะ และแจ้งปลายทาง ให้นำสินค้าเข้าตู้เย็นทันที เมื่อส่งให้ปลายทางแล้ว เนื่องจากสินค้าเป็นของสด ต้องการความเย็น',
          value:
            'รบกวนโทรหาปลายทางก่อนออกจัดส่งด้วยนะคะ และแจ้งปลายทาง ให้นำสินค้าเข้าตู้เย็นทันที เมื่อส่งให้ปลายทางแล้ว เนื่องจากสินค้าเป็นของสด ต้องการความเย็น'
        },
        {
          label: 'Other',
          value: 'Other'
        }
      ]

      return options
    },
    orderPayOptions() {
      var options = [
        {
          label: this.$t('เก็บเงินปลายทาง'),
          value: 'cod'
        },
        {
          label: this.$t('โอนเงิน'),
          value: 'payment'
        }
      ]

      return options
    },
    orderStatusOptions() {
      if (this.$store.state.nestlePages.some((page) => page.pageid == this.selectedBot.pageid)) {
        return ACOMMERCE_STATUS_OPTIONS.map((status) => ({
          label: this.$t(`ACOMMERCE_${status}`),
          value: status
        }))
      } else {
        return STATUS_OPTIONS.map((status) => ({
          ...status,
          label: this.$t(status.label)
        }))
      }
    },
    foodguruOrderStatusOptions() {
      var options = [
        {
          label: 'Reviewing',
          value: 'Reviewing'
        },
        {
          label: 'Payment สำเร็จ',
          value: 'Payment สำเร็จ'
        },
        {
          label: 'เปิดบิลสำเร็จ',
          value: 'เปิดบิลสำเร็จ'
        },
        {
          label: 'ส่งของสำเร็จ',
          value: 'shipped'
        }
      ]

      return options
    },
    dtacGamingOrderStatusOptions() {
      let order = this.order
      let options = [
        {
          label: 'จ่ายแล้ว',
          value: 'paid'
        },
        {
          label: 'เติมแล้ว',
          value: 'refilled',
          $isDisabled: order.note ? false : true
        },
        {
          label: 'แก้ไข',
          value: 'modify',
          $isDisabled: order.status !== 'refilled' ? true : false
        }
      ]

      return options
    },
    jsonValue() {
      try {
        if (this.order && this.order.jsonvalue) {
          return JSON.parse(this.order.jsonvalue)
        } else {
          return null
        }
      } catch (error) {
        return null
      }
    },
    isCheck() {
      return this.cbAll && this.cbAll.includes(this.order.id)
    },
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    shippingAddressPosition() {
      if (this.order.nameaddress && this.order.nameaddress !== '') {
        var regex = /[\d.]+?[,][\d.]+/g
        if (this.order.nameaddress.match(regex)) {
          var resultMatch = this.order.nameaddress.match(regex)
          var position = resultMatch[0].split(',')
          if (position.length > 1) {
            return {
              lat: position[0],
              lng: position[1]
            }
          }
        }
      }
      return this.order.nameaddress
    },
    orderDetailFormat: {
      get() {
        var text = ''
        try {
          text = JSON.parse(this.order.productdetail)
        } catch (error) {
          text = this.order.productdetail
        }
        return text
      },
      set(value) {
        if (typeof value == String) {
          this.$set(this.order, 'productdetail', value)
        } else {
          this.$set(this.order, 'productdetail', JSON.stringify(value))
        }
      }
    },
    order: {
      get() {
        const vm = this
        if (['foodguru'].includes(this.selectedBot.theme)) {
          try {
            vm.status = vm.foodguruOrderStatusOptions.find(function (element) {
              return element.value == vm.value.status
            })
          } catch (error) {}
        } else if (['dtac-gaming'].includes(this.selectedBot.type)) {
          try {
            vm.status = vm.dtacGamingOrderStatusOptions.find(function (el) {
              return el.value == vm.value.status
            })
          } catch (error) {}
        } else {
          try {
            vm.status = vm.orderStatusOptions.find(function (element) {
              return element.value == vm.value.status
            })
          } catch (error) {}
        }

        return vm.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    tags: function () {
      var tags = []
      if (this.order.tags && this.order.tags.trim() != '') {
        tags = this.order.tags.split(',')
      }
      return tags
    },
    shippingType() {
      return this.handleGetShippingType()
    },
    showSetShippingDateTime() {
      if (this.isTremendous) {
        return true
      } else {
        return false
      }
    },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    }
  },
  mounted() {
    const vm = this
    if (vm.order.order_json) {
      vm.order_json = JSON.parse(vm.order.order_json)
      if (vm.order_json) {
        if (vm.order_json.specialRequests && vm.order_json.specialRequests[0] === 'COD')
          vm.statusPay = {
            label: vm.$t('ชำระปลายทาง'),
            value: 'cod'
          }

        if (vm.order_json.deliveries) {
          vm.nameEdit = vm.order_json.deliveries[0].toContact.name
          vm.driverRemark = vm.order_json.deliveries[0].remarks
        } else {
          vm.nameEdit = vm.order.nameaddress.split(' , ')[0] || ''
          vm.driverRemark = vm.order_json.remarks
        }
      }
    }

    if (vm.order && vm.shippingOptions) {
      vm.shippingValue = vm.handleGetShippingType()
    }

    if (['176922345693076', '809510349133469', '103876431747147'].includes(vm.selectedBot.pageid)) {
      var order = vm.orderDetailFormat.find((el) => {
        return el.cart_remark != '' || el.cart_remark != null
      })

      if (order) {
        vm.cart_remark = order.cart_remark
      }
    }
    const beginningTime = moment()
    const endTime = moment('9:00pm', 'h:mma')

    vm.mindate = beginningTime.isBefore(endTime)
      ? moment().add('2', 'days').format('YYYY-MM-DD')
      : moment().add('3', 'days').format('YYYY-MM-DD')

    vm.afterMounted()
  },
  methods: {
    goToLivechat: function (user, app) {
      let routeData = this.$router.resolve({
        name: 'livechat',
        path: '/' + this.currentLang + '/livechat',
        query: {
          userid: user.userid,
          app: app
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleGetShippingType() {
      let shippingType = ''
      try {
        let jsondata = JSON.parse(this.order.shippingtype)

        shippingType = jsondata.type ? jsondata.type : ''
      } catch (error) {
        shippingType = this.order.shippingtype
      }
      let shippingValue = null
      try {
        if (typeof this.shippingOptions !== 'undefined' && this.shippingOptions) {
          shippingValue = this.shippingOptions.find((el) => {
            return el.name == shippingType || shippingType == el[4]
          })
        }
      } catch (error) {
        console.error(error)
      }
      return shippingValue
    },
    changeLocation(payload) {
      const vm = this
      vm.$store.dispatch('loading')
      if (vm.order_json.data) {
        vm.order_json.data.stops[1].coordinates.lat = payload.location.lat.toString()
        vm.order_json.data.stops[1].coordinates.lng = payload.location.lng.toString()
        vm.order_json.data.stops[1].address =
          vm.name + ' , ' + payload.placesinfolabel + ' , ' + vm.phoneNumber
      } else {
        vm.order_json.stops[1].location.lat = payload.location.lat.toString()
        vm.order_json.stops[1].location.lng = payload.location.lng.toString()
        vm.order_json.stops[1].addresses.th_TH.displayString =
          vm.name + ' , ' + payload.placesinfolabel + ' , ' + vm.phoneNumber
      }
      vm.order.nameaddress = vm.name + ' , ' + payload.placesinfolabel + ' , ' + vm.phoneNumber
      vm.order.order_json = JSON.stringify(vm.order_json)
      vm.editOrderApi(vm.order)
    },
    editAddress(summaryLalamove) {
      const vm = this
      if (summaryLalamove.nameaddress && typeof summaryLalamove.nameaddress === 'string') {
        vm.phoneNumber = summaryLalamove.nameaddress.split(' , ')[2]
        vm.name = summaryLalamove.nameaddress.split(' , ')[0]
      }
      if (summaryLalamove.order_json) {
        vm.order_json = JSON.parse(summaryLalamove.order_json)
        vm.showToAddress = true
      }
    },
    editOrderApi(dataEdit) {
      const vm = this
      api.editNvbbOrderSummary(dataEdit, function (error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
          return
        }
        vm.$store.dispatch('loading')
      })
    },
    editAddressHub(hubSelect) {
      let hubAddress = null
      this.nvbb.hubLocationOptions.filter((item) => {
        if (item.value == hubSelect) {
          hubAddress = item
        }
      })

      this.dataEdit.remark = `${hubAddress.text} \n ${hubAddress.desc} \n ${hubAddress.link}`
      this.editOrderApi(this.dataEdit)
      this.toggleHub = false
      this.$store.dispatch('loading')
    },
    editAddressDroppoint() {
      var vm = this
      if (vm.droppointSelect) {
        vm.$store.dispatch('loading')
        var drop = vm.$store.state.nvbbDroppointLocationOptions.find(function (element) {
          return element.value == vm.droppointSelect
        })

        if (
          drop.location &&
          drop.location[0].lat_long &&
          typeof drop.location[0].lat_long === 'string'
        ) {
          if (vm.order_json.data) {
            vm.order_json.data.stops[0].coordinates.lat = drop.location[0].lat_long.split(', ')[0]
            vm.order_json.data.stops[0].coordinates.lng = drop.location[0].lat_long.split(', ')[1]
            vm.order_json.data.stops[0].address = drop.displayString
          } else {
            vm.order_json.stops[0].location.lat = drop.location[0].lat_long.split(', ')[0]
            vm.order_json.stops[0].location.lng = drop.location[0].lat_long.split(', ')[1]
            vm.order_json.stops[0].addresses.th_TH.displayString = drop.displayString
          }
          vm.order_json.shop_fee = drop.shopCharg
          vm.order_json.filterName = drop.filterName

          if (vm.order_json.deliveries) {
            let customerPhone =
              vm.order.nameaddress.split(' , ')[vm.order.nameaddress.split(' , ').length - 1]
            if (customerPhone.charAt(0) == '0') {
              customerPhone = customerPhone.slice(1)
              customerPhone = '+66' + customerPhone
            }
            vm.order_json.deliveries[0].toContact.phone = customerPhone
          }
        }

        vm.dataEdit.order_json = JSON.stringify(vm.order_json)
        vm.dataEdit.remark =
          drop.text + ' ' + drop.desc + ' ช่วงเวลาจัดส่งประมาณ ' + drop.timePeriod
        vm.editOrderApi(vm.dataEdit)
        vm.nameEdit = vm.order.nameaddress.split(' , ')[0] || ''
        vm.editName()
        vm.toggleDroppoint = false
      }
    },
    toggleDroppointClick(item) {
      const vm = this
      vm.dataEdit = item
      if (
        item.order_json &&
        typeof item.order_json !== 'undefined' &&
        JSON.parse(item.order_json)
      ) {
        vm.order_json = JSON.parse(item.order_json)
      } else {
        vm.order_json = {}
        vm.order_json.data = {
          serviceType: 'MOTORCYCLE',
          specialRequests: ['FOOD_DELIVERY'],
          language: 'th_TH',
          stops: [
            {
              coordinates: {
                lat: null,
                lng: null
              },
              address: null
            },
            {
              coordinates: {
                lat: null,
                lng: null
              },
              address: null
            }
          ]
        }
      }
      const drop = vm.$store.state.nvbbDroppointLocationOptions.find(function (element) {
        return element.filterName == vm.order_json.filterName
      })
      if (drop) {
        vm.droppointSelect = drop.value
      }
      vm.toggleDroppoint = true
    },
    allowedDates(val) {
      if (this.nvbb.shippingType == 'express') {
        let postcode = null
        try {
          if (!this.nvbb.shippingAddress) throw new Error('Not found address')
          postcode = this.nvbb.shippingAddress.trim().match(/[1-9]{1}[0-9]{4}$/)
          if (postcode && postcode.length > 0) {
            postcode = postcode[0].trim()
          } else if (!postcode) {
            throw new Error('Not found postcode')
          } else {
            throw new Error('Many postcode')
          }
        } catch (error) {
          console.error(error)
          postcode = false
        }

        if (!postcode) {
          return false
        }
        let location = getBangkokLocation(postcode, this.nvbb.shippingAddress)
        const days = ['2', '3', '4', '6']
        // อังคาร พุธ พฤ ส
        if (['BKK', 'MET', 'REM'].includes(location)) {
          return days.includes(moment(val).weekday().toString())
          //scg
        } else {
          return days.includes(moment(val).weekday().toString())
          //interexpress
        }
      }

      return ['2', '4', '6'].includes(moment(val).weekday().toString()) // other
    },
    cancelMoveTo() {
      this.orderToMove = null
      this.showMoveToOrder = false
    },
    async moveToPreorder(order) {
      try {
        let nameaddress = order.nameaddress ? order.nameaddress.split(',') : []
        if (nameaddress.length >= 3) {
          nameaddress.splice(0, 1)
          nameaddress.splice(nameaddress.length - 1, 1)
          this.nvbb.shippingAddress = nameaddress.join(',')
        }

        let products = JSON.parse(order.productdetail)
        if (products && products.length > 0) {
          let result = products
            .map((el) => {
              if (el.sku) {
                let sku = el.sku.split('_')
                if (sku.length == 2) {
                  let product_name = sku[0],
                    stock_name = sku[1]

                  return {
                    photourl: el.photourl,
                    name: product_name,
                    option: stock_name,
                    quantity: el.quantity
                  }
                }
              }
              return false
            })
            .filter((el) => el != false)

          if (result && result.length > 0) {
            this.orderToMove = _.cloneDeep(order)
            this.orderToMove.productdetail = result
            this.showMoveToOrder = true
            return false
          }
        }
        await this.$swal.fire({
          title: this.$t('ไม่สามารถโอนย้ายไปยัง Pro-order ได้?'),
          type: 'warning',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
      } catch (error) {
        console.error(error)
      }
    },
    async onProceedNvbbPreorder(order) {
      var result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      this.nvbb.loading = true
      let customerName = '',
        customerPhone = '',
        shippingAddress = '',
        shippingType

      try {
        let nameaddress = order.nameaddress ? order.nameaddress.split(',') : []
        if (nameaddress.length >= 3) {
          customerName = nameaddress[0]
          nameaddress.splice(0, 1)
          customerPhone = nameaddress[nameaddress.length - 1]
          nameaddress.splice(nameaddress.length - 1, 1)
          shippingAddress = nameaddress.join(',')
        }
        var address = customerName + ' , ' + shippingAddress + ' , ' + customerPhone
        var cart = order.productdetail

        var hubAddress = ''
        let hublocation
        if (['hub', 'hub+msg'].includes(this.nvbb.shippingType)) {
          hublocation = this.nvbb.hubLocationOptions.find((el) => {
            return el.value == this.nvbb.hubLocation
          })

          if (hublocation) {
            hubAddress = `${hublocation.text} \n${hublocation.desc} \n${hublocation.link}`
          }

          if (this.nvbb.shippingType == 'hub+msg') {
            hubAddress = hubAddress + ' (HUB to home)'
          }
        } else if (this.nvbb.shippingType == 'drop') {
          hublocation = vm.$store.state.nvbbDroppointLocationOptions.find((el) => {
            return el.value == this.nvbb.hubLocation
          })

          if (hublocation) {
            hubAddress = `${hublocation.text || ''} \n${hublocation.desc || ''} \n${
              hublocation.link || ''
            }`
          }
        }

        if (['hub', 'hub+msg'].includes(this.nvbb.shippingType)) shippingType = 'hub'
        else if (['express'].includes(this.nvbb.shippingType)) {
          let postcode = null
          try {
            shippingAddress = shippingAddress ? shippingAddress.trim() : ''
            postcode = shippingAddress.match(/[ ][1-9]{1}[0-9]{4}$/)
            if (postcode && postcode.length > 0) {
              postcode = postcode[0].trim()
            } else {
              throw new Error('Many postcode')
            }
          } catch (error) {
            console.error(error)
            postcode = false
          }

          if (!postcode) {
            this.nvbb.loading = false
            return false
          }
          let location = getBangkokLocation(postcode, shippingAddress)

          if (['BKK', 'MET'].includes(location)) {
            shippingType = 'scg'
          } else {
            shippingType = 'interexpress'
          }
        } else shippingType = this.nvbb.shippingType

        var request = {
          cart: cart,
          pageid: this.selectedBot.pageid,
          userid: order.userid,
          address: address,
          shippingdate: this.nvbb.pickupdate
            ? moment(this.nvbb.pickupdate).format('YYYY-MM-DD')
            : null,
          shippingtype: shippingType,
          phone: customerPhone.trim(),
          name: customerName.trim(),
          remark: hubAddress,
          shippingcharge: this.calculateShippingPrice(order),
          from: 'livechat',
          isCutQuota: false
        }

        var response = await axios.post(config.serverUrl + 'nvbbbanktransfernotify', request, {
          headers: { AUTHORIZATION: 'Bearer xxx xxx' }
        })
        if (response.data.responsecode == 200) {
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
          this.showMoveToOrder = false
          this.orderToMove = false
        }
      } catch (error) {
        console.error(error)
      }

      this.nvbb.loading = false
    },
    calculateShippingPrice(order) {
      //
      let producttype = ['phytosmooz', 'phytomylk', 'phytoshot', 'none', 'other']
      let rate = 0

      // return {small: 0, large: 0};
      var bottles = {}
      producttype.forEach((el) => {
        bottles[el] = { small: 0, large: 0 }
      })

      let total = order.productdetail
        .map((el) => {
          let type, bottles
          let option = el.option.toLowerCase().split('-')
          if (producttype.includes(option[0])) {
            type = option[0]
            bottles = { small: 0, large: 0 }
            switch (option[1]) {
              case 'ขวดเล็ก':
                bottles = { small: el.quantity, large: 0 }
                break
              case 'ขวดใหญ่':
                bottles = { small: 0, large: el.quantity }
                break

              default:
                break
            }
          }
          return {
            name: el.name,
            type: type,
            bottle: bottles
          }
        })
        .reduce(
          (prev, cur) => {
            try {
              var type = cur.type.toLowerCase()

              if (prev[type] === undefined) {
                // eslint-disable-next-line no-undef
                prev[type] = _.cloneDeep(cur.bottle)
              } else {
                prev[type].small = prev[type].small + cur.bottle.small
                prev[type].large = prev[type].large + cur.bottle.large
              }
            } catch (error) {
              console.error(error)
            }
            return prev
          },
          { ...bottles }
        )

      let totalBottle = producttype
        .map((el) => {
          if (el == 'phytoshot') {
            return (total[el].large + total[el].small) / 2
          } else if (total[el] !== undefined) {
            return total[el].large + total[el].small
          } else return null
        })
        .filter((el) => {
          return el != null
        })
        .reduce((prev, curr) => {
          return prev + curr
        }, 0)
      try {
        rate = calculateShippingPrice({
          type: this.nvbb.shippingType,
          address: this.nvbb.shippingAddress,
          total: totalBottle
        })
        if (rate != false) return Math.ceil(rate)
        return rate
      } catch (error) {
        return false
      }
    },
    afterMounted() {},
    onSelectShipping(val) {
      this.order.shippingtype = val.name
      this.$emit('input', this.order)
      this.$emit('onChangeStatus')
    },
    getOrderById(id) {
      return new Promise((resolve, reject) => {
        api.getordersbyid({ id: id, pageid: this.selectedBot.pageid }, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
            return
          }

          resolve(response)
        })
      })
    },
    async onPrinCover(allcontents, payload) {
      var orders = []
      if (allcontents) {
        var response = await this.getOrderById(this.order.id)
        orders = response.data ? response.data : []
      } else orders = [this.order]
      payload.printPdf(orders)
    },
    onImageLoadFailure(event) {
      event.target.src = '/static/img/assets/payment/other_charge_logo.png'
    },
    assignCb(id) {
      this.$emit('assignCb', id)
    },
    onSelectOrderStatus: async function (status) {
      var order = this.order

      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        let data = {
          pageid: this.selectedBot.pageid,
          orderid: this.order.id
        }
        if (status.value != 'canceled' && order.status == 'canceled') {
          data.type = 'DELETE'
          await api.nvbb_pre_order_stock_update(data)
        } else if (order.status != 'canceled' && status.value == 'canceled') {
          data.type = 'ADD'
          await api.nvbb_pre_order_stock_update(data)
        }
      } else if (!['1227843817265057'].includes(this.selectedBot.pageid)) {
        if (status.value != 'canceled' && order.status == 'canceled') {
          api.orderstockdelete({ orderid: this.order.id }, () => {})
        } else if (order.status != 'canceled' && status.value == 'canceled') {
          api.orderstockadd({ orderid: this.order.id }, () => {})
        }
      }

      order.status = status.value
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    onSelectOrderPay: async function (statusPay) {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (statusPay) {
          order_json.specialRequests = ['COD', 'LALABAG']
        } else {
          order_json.specialRequests = ['LALABAG']
        }
        order.order_json = JSON.stringify(order_json)
      }
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    editRemarks() {
      this.onSelectRemarkToDriver(this.driverRemark)
    },
    editName() {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (this.nameEdit) {
          var name = ''
          if (order_json.deliveries && order_json.deliveries.length > 0) {
            order_json.deliveries[0].toContact.name = this.nameEdit
          }
          if (order.nameaddress && typeof order.nameaddress === 'string') {
            order.nameaddress.split(' , ').map((item, i) => {
              if (i !== 0 && i !== order.nameaddress.split(' , ').length - 1) {
                name += item + ' , '
              } else if (i === order.nameaddress.split(' , ').length - 1) {
                name += item
              }
            })
          }
          order.nameaddress = this.nameEdit + ' , ' + name
          order.order_json = JSON.stringify(order_json)
        }
      }

      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },

    onSelectRemarkToDriver(driverRemark) {
      var order = this.order
      var order_json = JSON.parse(order.order_json)
      if (this.selectedBot.theme == 'nvbb' && this.$route.query.tab == 'nvbb-order-summary') {
        if (driverRemark.value) {
          if (order_json.deliveries) {
            order_json.deliveries[0].remarks = driverRemark
          } else {
            order_json.remarks = driverRemark
          }
        }
        order.order_json = JSON.stringify(order_json)
      }

      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    onCityfreshUpdateShippingdate(val) {
      let order = this.order
      order.shipping_date = val.shipping_date
      order.shipping_time = val.shipping_time
      this.$emit('updateOrder', 'save')
    },
    onUpdateShippingdate(val) {
      let order = this.order
      order.shipping_date = val.shipping_date
      order.shipping_new_date = val.shipping_date
      this.$emit('updateOrder', 'save')
    },
    handleUploadedReceipt() {
      let order = this.order
      this.$emit('input', order)
      this.$emit('onChangeStatus')
    },
    async handleSendReceipt() {
      this.$store.dispatch('loading')
      try {
        await dtacGamingApi.postSendReceipt({
          data: {
            page_id: this.selectedBot.pageid,
            order_id: this.order.id
          }
        })
        this.$swal.fire({
          title: this.$t('Success'),
          type: 'success',
          confirmButtonText: this.$t('Confirm')
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.$store.dispatch('loading')
      }
    }
  },
  watch: {
    cbAll(newVal, oldVal) {
      if (this.cbAll && this.cbAll.includes(this.order.id)) this.cb = true
      else this.cb = false
    },
    showPrint: function (newVal, oldVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    },
    order(newVal) {
      if (newVal) {
        this.shippingValue = this.handleGetShippingType()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/template/ecommerce/OrderSummaryItem.js